/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';

import services from '../Service';

var screenCode = "VIEWOUTLETORDERPRODUCTWISE"

export default function ViewOrderOutletDetailsByProductWise(props) {

    const navigate = useNavigate();

    const componentRef = useRef();

    const [csvHeaders, SetCsvHeaders] = useState([]);

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'View Outlet Orders - Productwise'
    });

    const [datevalue, setDateValue] = React.useState(new Date().setDate(new Date().getDate()));
    const [productList, setProductList] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [plotDetails, setPlotDetails] = useState([]);
    const [value, setValue] = useState(0);

    const [formData, setFormData] = useState({
        productID: '',
        date: new Date(datevalue).toISOString()
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        productID: '',
        date: ''
    });

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    // const [permissionList, setPermissions] = useState({
    //     isGroupFilterEnabled: false,
    //     isFactoryFilterEnabled: false
    // });

    const classes = useStyles();

    const viewOrderOutletDetailsSchema = Yup.object().shape({
        productID: Yup.number().min(1, 'Please Select Product Name').required('Product Name required'),
        date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            productID: formData.productID,
            date: formData.date
        },

        validationSchema: viewOrderOutletDetailsSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
            setIsHidden(true)
        }
    });

    //tobackend
    async function SubmitForm() {
        let res = await services.GetOutletDetailsByproductIdAndDate(
            formik.values.productID,
            new Date(datevalue).toISOString().split('T')[0]
        );
        res.forEach(x => {
            x.orderDate = x.orderDate.split('T')[0];

        });
        setPlotDetails(res);
        createDataForExcel(res);
        getSelectedDropdownValuesForReport();
    }



    async function createFile() {
        var file = await createDataForExcel(plotDetails);
        var settings = {
            sheetName: 'Outlet Order Report (Productwise)',
            fileName: 'Outlet Order Report (Productwise)',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Outlet Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Factory Name	': x.factoryName,
                    'Order Date': x.orderDate.split('T')[0],
                    'Quantity': x.quantity
                }
                res.push(vr);
            });
        }

        return res;
    }
    //------------------------------------------

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        setPlotDetails([]);
        setDateValue(new Date().setDate(new Date().getDate()));
        formik.resetForm();
    }

    async function GetAllProducts() {
        let res = await services.GetAllProductsForDropDown();
        if (res != null) {
            setProductList(res);
        }
    }
    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllProducts();
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWOUTLETORDERPRODUCTWISE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
    }

    function getSelectedDropdownValuesForReport() {

        let result = productList.find(x => x.productID == formik.values.productID)
        var dateSelected = new Date(datevalue).toISOString().split('T')[0];

        setSelectedSearchValues({
            ...selectedSearchValues,
            productID: result,
            date: dateSelected,
        });
    }

    return (
        <>
            <LoadingComponent />
            <Page title=" Outlet products  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Product Name*"
                                        value={formik.values.productID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productID')}
                                        error={Boolean(touched.productID && errors.productID)}
                                        helperText={touched.productID && errors.productID}
                                    >
                                        <MenuItem key={0} value={0}>Select Product</MenuItem>
                                        {productList.map((option) => (
                                            <MenuItem key={option.productID} value={option.productID}>
                                                {option.productName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            fullWidth
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            inputFormat="MM/DD/YYYY"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="button" variant="outlined" color="error"
                                        onClick={() => clearAll()}
                                    >
                                        Clear
                                    </Button>
                                    <Button type="submit" color="secondary" variant="outlined"
                                    >
                                        Search
                                    </Button>
                                </Stack>
                                <br />
                                <Divider variant="middle" />
                                <br />
                                <>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {plotDetails.length != 0 ?
                                            <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                                <Paper className={classes.root}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="collapsible table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: 'bold' }}>Factory Name</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold' }}>Order Date</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {plotDetails.map((row) => (
                                                                    < TableRow
                                                                        //key={i}
                                                                        row={row} >
                                                                        <TableCell component="th" scope="row">
                                                                            {row.factoryName}
                                                                        </TableCell>
                                                                        <TableCell >{parseFloat(row.quantity).toFixed(2)}</TableCell>
                                                                        <TableCell >{row.orderDate}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>
                                            </Card> : null}
                                    </Stack>
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>

                    {/* -----------------------pdf------------------------- */}
                    {plotDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Outlet Product Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={plotDetails}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box> : null}
                    {/* ------------------------------------------------------------ */}
                </Container>
            </Page>
        </>
    );
}